module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Привіт, " + _vm._s(_vm.firstname))]), _vm._v(" "), _c('h2', [_vm._v("Трекер відвідуваності")]), _vm._v(" "), (_vm.schoolClasses === undefined) ? _c('p', [_c('i', [_vm._v("Завантаження...")])]) : _vm._e(), _vm._v(" "), (_vm.schoolClasses !== undefined) ? _c('p', [_vm._v("Виберіть свій шкільний клас:")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.schoolClasses), function(schoolClass, index) {
    return _c('button', {
      staticClass: "btn btn-outline-dark",
      on: {
        "click": function($event) {
          _vm.$router.push('/attendance/' + schoolClass)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "book"
      }
    }), _vm._v(_vm._s(schoolClass))], 1)
  }), _vm._v(" "), (_vm.cognitoGroups.includes('AdministratorGroup')) ? _c('h2', [_vm._v("Administrator accesses only")]) : _vm._e(), _vm._v(" "), (_vm.cognitoGroups.includes('AdministratorGroup')) ? _c('button', {
    staticClass: "btn btn-outline-dark",
    on: {
      "click": function($event) {
        _vm.$router.push('/statistics/')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v("Statistics")], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc1bda6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 613
// module chunks = 1